import { useQuery } from "@tanstack/react-query";
import { Coins, Banknote, Receipt } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip, CartesianGrid } from "recharts";
import { get } from "@/lib/api";
import { shortDate } from "@/lib/data";

export default function Finance() {
  const { data } = useQuery({ queryKey: ["partner-finance"], queryFn: () => get("/partner/finance") });
  if (!data) return <p className="text-[#64748B]">Yükleniyor…</p>;

  const chartData = data.series.map((d) => ({ name: shortDate(d.date), kredi: d.credits }));

  const cards = [
    { icon: Coins, label: "Toplam kredi geliri", value: `${data.total_credits}`, hint: "onaylı + katılan" },
    { icon: Banknote, label: "Tahmini hakediş", value: `₺${data.estimated_payout_tl.toLocaleString("tr-TR")}`, hint: "1 kredi ≈ ₺25" },
    { icon: Receipt, label: "Geçerli rezervasyon", value: data.booking_count, hint: "adet" },
  ];

  return (
    <div>
      <h1 className="text-2xl font-semibold tracking-tight">Finans</h1>
      <p className="text-sm text-[#64748B]">Gelir ve hakediş özeti (demo)</p>

      <div className="mt-5 grid gap-4 sm:grid-cols-3">
        {cards.map((c) => (
          <div key={c.label} className="rounded-md border border-[#E2E8F0] bg-white p-5">
            <div className="flex items-center justify-between"><span className="text-sm text-[#64748B]">{c.label}</span><c.icon className="h-4 w-4 text-[#94A3B8]" /></div>
            <p className="mt-3 text-3xl font-semibold">{c.value}</p>
            <p className="mt-1 text-xs text-[#94A3B8]">{c.hint}</p>
          </div>
        ))}
      </div>

      <div className="mt-6 rounded-md border border-[#E2E8F0] bg-white p-5">
        <h2 className="mb-4 font-semibold">Günlük kredi geliri</h2>
        <div className="h-72">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#F1F5F9" vertical={false} />
              <XAxis dataKey="name" tick={{ fontSize: 12, fill: "#64748B" }} axisLine={false} tickLine={false} />
              <YAxis tick={{ fontSize: 12, fill: "#64748B" }} axisLine={false} tickLine={false} />
              <Tooltip cursor={{ fill: "#F1F5F9" }} contentStyle={{ borderRadius: 8, border: "1px solid #E2E8F0", fontSize: 13 }} />
              <Bar dataKey="kredi" fill="#2D2926" radius={[4, 4, 0, 0]} maxBarSize={40} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
